/**
 * Observer for all appear on scroll
 */

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const delay = entry.target.dataset.delay;
        if (delay) {
          setTimeout(() => {
            entry.target.classList.add("Shown");
          }, delay);
        } else {
          entry.target.classList.add("Shown");
        }
        observer.unobserve(entry.target);
      }
    });
  },
  {
    threshold: 0.1,
  },
);

const appearOnScrollElems = document.querySelectorAll(".AppearOnScroll");

appearOnScrollElems.forEach((elem) => {
  observer.observe(elem);
});

subscribe(PUB_SUB_EVENTS.contentAdded, (data) => {
  const newElems = data.content.querySelectorAll(".AppearOnScroll");
  newElems.forEach((elem) => {
    observer.observe(elem);
  });
});

class scrollTimeline {
  constructor(section, callback) {
    this.section = section;
    this.callback = callback;
    this.sleeping = true;
    this.stopped = false;

    this.oldRatio = 0;
    this.ratio = 0;
    this.init();
  }

  init() {
    // Set up scroll observer
    window.addEventListener("scroll", this.onScroll.bind(this));
  }

  onScroll() {
    // Check if the section is in view
    const section = this.section.getBoundingClientRect();
    const top = section.top;
    const bottom = section.bottom;

    let scrollRatio =
      (window.innerHeight - top) / (window.innerHeight + section.height);
    // keep ratio between 0 and 1
    this.ratio = Math.min(1, Math.max(0, scrollRatio));
    this.update(scrollRatio);

    if (top < window.innerHeight && bottom > 0) {
      console.log("not sleeping");
      this.sleeping = false;
    } else {
      console.log("sleeping");
      this.sleeping = true;
    }
  }

  update() {
    if (this.stopped) {
      return;
    }
    if (this.sleeping) {
      requestAnimationFrame(this.update.bind(this));
      return;
    }

    // ease the ratio
    const ratio = (this.oldRatio += (this.ratio - this.oldRatio) * 0.01);

    this.oldRatio = ratio;

    this.callback(ratio);
    requestAnimationFrame(this.update.bind(this));
  }

  destroy() {
    console.log("destroyed");
    window.removeEventListener("scroll", this.onScroll.bind(this));
    this.stopped = true;
  }
}

/**
 * Utils easing curves
 * */
function easeInOutSine(x) {
  return -(Math.cos(Math.PI * x) - 1) / 2;
}

function easeInOutCubic(x) {
  return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
}

function easeOutSine(x) {
  return Math.sin((x * Math.PI) / 2);
}

function easeOutCubic(x) {
  return 1 - Math.pow(1 - x, 3);
}

/**
 * Parallax inner images using scroll timeline
 */

const parallaxSections = document.querySelectorAll(".ParallaxImage");
parallaxSections.forEach((section) => {
  const parallaxImage = section.querySelector(".ParallaxInner");

  const parallaxTimeline = new scrollTimeline(section, (ratio) => {
    const translateY = ratio * 15;
    parallaxImage.style.translate = `0 ${translateY}%`;
  });
});

/**
 * Accordions
 */

const accordions = document.querySelectorAll(".Accordion");

accordions.forEach((accordion) => {
  const accordionTriggers = accordion.querySelectorAll(
    ".Accordion--tab-trigger",
  );

  accordionTriggers.forEach((trigger) => {
    const content = trigger.querySelector(".Accordion--tab-content");
    const contentHeight = content.scrollHeight;
    trigger.style.setProperty("--height", `${contentHeight}px`);

    window.addEventListener("resize", () => {
      const contentHeight = content.scrollHeight;
      trigger.style.setProperty("--height", `${contentHeight}px`);
    });

    const collapse = trigger.querySelector(".Accordion--tab");

    trigger.addEventListener("click", () => {
      accordionTriggers.forEach((trigger) => {
        const oldCollapse = trigger.querySelector(".Accordion--tab");
        if (oldCollapse != collapse) {
          oldCollapse.classList.remove("Open");
        }
      });
      collapse.classList.toggle("Open");
    });
  });
});

const variableHeight = document.querySelectorAll(".VariableHeight");

variableHeight.forEach((section) => {
  const variableHeightContentHeight = section.scrollHeight;
  section.style.setProperty("--height", `${variableHeightContentHeight}px`);

  window.addEventListener("resize", () => {
    const variableHeightContentHeight = section.scrollHeight;
    section.style.setProperty("--height", `${variableHeightContentHeight}px`);
  });
});

setTimeout(() => {
  const splitTexts = document.querySelectorAll(".SplitText");

  splitTexts.forEach((text) => {
    const stagger = text.dataset.stagger;
    const textContent = text.textContent.trim().split("\n")[0];
    const html = text.innerHTML;
    const letters = textContent.split("");
    text.innerHTML = "";
    letters.forEach((letter) => {
      // copy innerHTML for each letter
      const letterHTML = html.replace(new RegExp(textContent, "g"), letter);
      text.innerHTML += letterHTML;
    });

    // get all children letters
    const children = text.children;
    const childrenList = Array.from(children);

    childrenList.forEach((child, index) => {
      if (child.textContent.trim().split("\n")[0] === "")
        child.classList.add("SplitText--space");

      child.style.setProperty("--delay", `${(index * stagger).toFixed(2)}s`);
      child.classList.add("SplitText--letter");
      child.classList.add("TorqueHover");
    });
  });

  const torqueHovers = document.querySelectorAll(".TorqueHover");

  torqueHovers.forEach((hover) => {
    const content = hover.children;
    const contentList = Array.from(content);

    // clone hover and class it TorqueClone
    const clone = document.createElement("div");
    clone.classList.add("TorqueClone");
    clone.innerHTML = hover.innerHTML;

    contentList.forEach((child) => {
      child.classList.add("TorqueHover--content");
    });

    hover.append(clone);
    publish(PUB_SUB_EVENTS.menuReady, { content: clone });
  });
}, 20);

const initEqualHeight = (section) => {
  const equalHeight = section.querySelectorAll(".EqualHeight");

  equalHeight.forEach((parent) => {
    const equalHeightElems = Array.from(
      parent.querySelectorAll(".EqualHeight--item"),
    );

    let maxHeight = 0;

    equalHeightElems.forEach((elem) => {
      const elemHeight = elem.scrollHeight;
      maxHeight = Math.max(maxHeight, elemHeight);
    });

    parent.style.setProperty("--height", `${maxHeight}px`);

    equalHeightElems.forEach((elem) => {
      elem.style.setProperty("--height", `${maxHeight}px`);
    });

    window.addEventListener("resize", () => {
      equalHeightElems.forEach((elem) => {
        const elemHeight = elem.scrollHeight;
        maxHeight = Math.max(maxHeight, elemHeight);
      });

      parent.style.setProperty("--height", `${maxHeight}px`);

      equalHeightElems.forEach((elem) => {
        elem.style.setProperty("--height", `${maxHeight}px`);
      });
    });
  });
};

initEqualHeight(document);

class SplitText {
  constructor(element, mode = SplitText.MODES.LINE) {
    this.parent = element;
    this.mode = mode;
    this.text = element.textContent;

    this.fontSize = parseFloat(getComputedStyle(element).fontSize);
    this.fontFamily = getComputedStyle(element).fontFamily;

    this.segments = [];

    this.init();

    if (!this.onResize) {
      this.onResize = debounce(this.init.bind(this), 100);
      window.addEventListener("resize", this.onResize);
    }
  }

  init() {
    this.parent.innerHTML = "";

    switch (this.mode) {
      case SplitText.MODES.CHAR:
        this.initChar();
        break;
      case SplitText.MODES.WORD:
        this.initWord();
        break;
      case SplitText.MODES.LINE:
        this.initLine();
        break;
      default:
        break;
    }
  }

  initLine() {
    this.segments = [];

    fontsCtx.font = `${this.fontSize}px ${this.fontFamily}`;
    const lines = wrapText(fontsCtx, this.text, 0, 0, this.parent.clientWidth);

    lines.forEach((line) => {
      const span = document.createElement("span");
      span.textContent = line;
      span.style.display = "inline-block";
      span.classList.add("Split--line");
      this.parent.appendChild(span);
      this.segments.push(span);
    });
  }

  initWord() {
    this.segments = [];

    const words = this.text.split(" ");
    words.forEach((word) => {
      const span = document.createElement("span");
      span.textContent = word;
      span.classList.add("Split--word");
      this.parent.appendChild(span);
      this.segments.push(span);
    });
  }

  initChar() {
    this.segments = [];

    const chars = this.text.split("");
    chars.forEach((char) => {
      const span = document.createElement("span");
      span.textContent = char;
      span.classList.add("Split--char");
      if (char === " ") {
        span.classList.add("Split--space");
      }
      this.parent.appendChild(span);
      this.segments.push(span);
    });
  }

  static get MODES() {
    return {
      CHAR: "char",
      WORD: "word",
      LINE: "line",
    };
  }
}

/* dependencies */
function wrapText(ctx, text, x, y, maxWidth) {
  let words = text.split(" ");
  let line = "";
  const lines = [];

  for (let i = 0; i < words.length; i++) {
    let testLine = line + words[i] + " ";
    let metrics = ctx.measureText(testLine);
    let testWidth = metrics.width;

    if (testWidth > maxWidth && i > 0) {
      ctx.fillText(line, x, y);
      lines.push(line);
      line = words[i] + " ";
    } else {
      line = testLine;
    }
  }

  lines.push(line);

  return lines;
}

let fontsCanvas = document.createElement("canvas");
let fontsCtx = fontsCanvas.getContext("2d");

fontsCtx.font = "16px ResidenzGroteskRegular";
fontsCtx.fillStyle = "black";
fontsCtx.textRendering = "geometricPrecision";

const initSplitText = () => {
  const splitTargets = document.querySelectorAll(".Split");

  splitTargets.forEach((target) => {
    const mode = target.dataset.mode || SplitText.MODES.LINE;
    const splitText = new SplitText(target, mode);
    splitText.init();
  });
};

initSplitText();

function debounce(callback, delay = 300) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      callback.apply(this, args);
    }, delay);
  };
}

class FixedScroller {
  constructor(fixedElement, options) {
    this.element = fixedElement;
    this._setOptions(options);
    this.init();
  }

  init() {
    // create wrapper for fixed element
    this.wrapper = document.createElement("div");
    this.wrapper.classList.add("fixed-scroller-wrapper");

    // insert is before the fixed element and append fixed element
    this.element.parentNode.insertBefore(this.wrapper, this.element);
    this.wrapper.appendChild(this.element);

    this._setInitialStyles();
    this._setEventListeners();
  }

  _setInitialStyles() {
    this.scrollHeight =
      this.element.scrollHeight +
      this.element.scrollHeight * this.options.scroll;

    // set styles for wrapper
    this.wrapper.style.height = this.scrollHeight + "px";
    this.wrapper.style.position = "relative";
  }

  _setEventListeners() {
    window.addEventListener("scroll", () => {
      this._scroll();
    });

    window.addEventListener("resize", () => {
      this._setInitialStyles();
    });
  }

  _setOptions(options) {
    // set options with default values
    this.options = {
      scroll: parseFloat(options.scroll) || 1, // factor of scroll height: 1 = +100% of element height
      top: parseFloat(options.top) || 0, // top offset
      callback: options.callback || function () {}, // callback function
    };
  }

  _scroll() {
    const scroll = window.scrollY - this.wrapper.offsetTop;
    const top = this.options.top;
    const scrollHeight = this.scrollHeight;
    const windowHeight = window.innerHeight;

    // check if element crossed the fixed position
    if (scroll > top && scroll <= top + scrollHeight - windowHeight) {
      this.element.style.position = "fixed";
      this.element.style.top = top + "px";
    } else if (scroll > top + scrollHeight - windowHeight) {
      this.element.style.position = "absolute";
      this.element.style.top = scrollHeight - windowHeight + "px";
    } else {
      this.element.style.position = "absolute";
      this.element.style.top = "0px";
    }

    // get fraction of scroll
    const fraction = (scroll - top) / (scrollHeight - windowHeight);

    // call callback function
    this.options.callback(fraction);
  }

  destroy() {
    // remove event listeners
    window.removeEventListener("scroll", this._scroll);
    window.removeEventListener("resize", this._setInitialStyles);

    // unwrap the fixed element
    this.wrapper.parentNode.insertBefore(this.element, this.wrapper);
    this.wrapper.parentNode.removeChild(this.wrapper);

    // remove styles
    this.element.style.position = "";
    this.element.style.top = "";
  }
}


document.addEventListener("DOMContentLoaded", ()=>{
    const buttons = document.querySelectorAll('[data-quick-add]');
    
    buttons.forEach(button => {
      button.addEventListener('click', async (event) => {
        if (!button || button.disabled) return;
        event.preventDefault();

        const label = button.querySelector('[data-quick-add-label]') || button;
        const originalText = label.textContent;
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        label.textContent = 'Adding…';

        try {
          const res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{
                id: Number(button.dataset.variantId),
                quantity: Number(button.dataset.quantity || 1)
              }]
            })
          });

          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');

          // Refresh the cart count
          const cart = await fetch(root + 'cart.js').then(r => r.json());
          document.querySelectorAll('[data-cart-count]').forEach(el => {
            el.textContent = cart.item_count;
          });

          // Let the theme (cart drawer, etc.) react to the update
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, added: data } }));

          label.textContent = 'Added!';
        } catch (err) {
          console.error(err);
          label.textContent = err.message.includes('sold out') ? 'Sold out' : 'Error, try again';
        } finally {
          setTimeout(() => {
            label.textContent = originalText;
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }, 1500);
        }
      })
    });
});